<form class="row g-3" [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm"
	*ngIf="UserModuleAccess==='Full'">
	<div class="row mb-3">
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('rank')}" id="rank"
					formControlName="rank" placeholder="">
				<label for="rank">Rank Name</label>
			</div>
			<p *ngIf="showError('rank')" class="text-danger">
				<span *ngIf="f.rank.errors?.required">
					Required
				</span>
				<span *ngIf="f.rank.errors?.incorrect">
					{{customError.rank}}
				</span>
			</p>
		</div>
		<div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
			<div class="form-floating">
				<textarea class="form-control" [ngClass]="{'is-invalid':showError('rankDesc')}" id="rankDesc"
					formControlName="rankDesc" placeholder=""></textarea>
				<label for="rankDesc">Description</label>
			</div>
			<p *ngIf="showError('rankDesc')" class="text-danger">
				<span *ngIf="f.rankDesc.errors?.required">
					Required
				</span>
				<span *ngIf="f.rankDesc.errors?.incorrect">
					{{customError.rankDesc}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<!-- <button type="submit" class="btn btn-sm btn-primary me-1">
				<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
				<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
				Submit
			</button> -->
			<button type="button" class="btn btn-sm btn-secondary" (click)="clearForm();">Cancel</button>
		</div>
	</div>
</form>
<div *ngIf="UserModuleAccess!=='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>